"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.summarisePayments = summarisePayments;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _ms = _interopRequireDefault(require("ms"));
var _occasion = _interopRequireDefault(require("occasion"));
var _gbp = _interopRequireDefault(require("gbp"));
var _table = _interopRequireDefault(require("../../../../core/table"));
var _chargeDate = _interopRequireDefault(require("./charge-date"));
var _constantParams = require("../../../../../constant-params");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// the partialQueries and the summarisePayments function from this component are also used
// in the statistics/finance-summary component
function summarisePayments(payments) {
  let promisedPayments = 0;
  let paidToClub = 0;
  let refundedByClub = 0;
  let refundedBeforePaymentReceived = 0;
  payments.map(payment => {
    promisedPayments += payment.expectedForClub;
    paidToClub += payment.paidToClub;
    payment.refunds.map(refund => {
      if (!refund.hasBeenRefundedThroughStripe && (refund.refundStatusRef === 'RFND' || refund.refundStatusRef === 'RVRT')) {
        refundedBeforePaymentReceived += refund.refundedByClub;
      }
      refundedByClub += refund.refundedByClub;
    });
  });
  const paymentsPending = promisedPayments - paidToClub - refundedBeforePaymentReceived;
  const expectedForClub = promisedPayments - refundedByClub;
  return {
    expectedForClub,
    paidToClub,
    refundedByClub,
    refundedBeforePaymentReceived,
    paymentsPending
  };
}
var _ref = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header"
}, /*#__PURE__*/_react.default.createElement("h3", null, "Fees Summary"));
var _ref2 = /*#__PURE__*/_react.default.createElement("td", null, "Payments Received");
var _ref3 = /*#__PURE__*/_react.default.createElement("td", null, "Payment Refunded before Collection");
var _ref4 = /*#__PURE__*/_react.default.createElement("td", null, "Payments Pending");
var _ref5 = /*#__PURE__*/_react.default.createElement("td", null, "Total Refunds");
var _ref6 = /*#__PURE__*/_react.default.createElement("th", null, "Total Expected");
var _ref7 = /*#__PURE__*/_react.default.createElement("td", null, "Defaulted Payments");
var _ref8 = /*#__PURE__*/_react.default.createElement("th", null, "Grand Total");
class FeesSummary extends _react.Component {
  render() {
    const competition = this.props.competition;
    const totals = summarisePayments(competition.payments);
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_table.default, null, /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, _ref2, /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, (0, _gbp.default)(totals.paidToClub))), /*#__PURE__*/_react.default.createElement("tr", null, _ref3, /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, (0, _gbp.default)(totals.refundedBeforePaymentReceived))), +this.props.yearID < _constantParams.thisYear ? null : /*#__PURE__*/_react.default.createElement("tr", null, _ref4, /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, (0, _gbp.default)(totals.paymentsPending))), /*#__PURE__*/_react.default.createElement("tr", null, _ref5, /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, '(' + (0, _gbp.default)(totals.refundedByClub) + ')')), /*#__PURE__*/_react.default.createElement("tr", null, _ref6, /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(totals.expectedForClub))), +this.props.yearID >= _constantParams.thisYear || totals.paymentsPending <= 0 ? null : [/*#__PURE__*/_react.default.createElement("tr", {
      key: "defaulted"
    }, _ref7, /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, (0, _gbp.default)(totals.paymentsPending))), /*#__PURE__*/_react.default.createElement("tr", {
      key: "grand"
    }, _ref8, /*#__PURE__*/_react.default.createElement("th", {
      className: "text-xs-right"
    }, (0, _gbp.default)(totals.expectedForClub - totals.paymentsPending)))]))), /*#__PURE__*/_react.default.createElement(_chargeDate.default, {
      competition: competition
    })));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************

  // the partialQueries and the summarisePayments function from this component are also used
  // in the statistics/finance-summary component
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(FeesSummary, "partialQueries", {
  Competition: _mergeBqlQueries({
    payments: {
      id: true,
      expectedForClub: true,
      paidToClub: true,
      refunds: {
        id: true,
        refundedByClub: true,
        refundDate: true,
        refundStatusRef: true,
        hasBeenRefundedThroughStripe: true
      }
    }
  }, _chargeDate.default.partialQueries.Competition)
});
var _default = exports.default = (0, _reactBicycle.connect)(FeesSummary);